"use client";

import { withFallback } from "../with-fallback";

export const ReserveBreakdownElement = withFallback({
	displayName: "ReserveBreakdownElement",
	type: "reserve-breakdown-element",
} as const);
